import _ from 'lodash';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as EventActions from './event.actions';
import { IStreamInfo } from '../models/stream-model';

export const eventFeatureKey = 'event';

export interface State extends EntityState<any> {
  switcher: boolean;
  selectedEvent: any;
  search: string;
  eventConfig: any;
  allStreams?: IStreamInfo[];
}

export function selectEventId(event: any): string {
  //In this case this would be optional since primary key is id
  switch(event.type) {
    case 0:
      return event.inPersonEventInfo.id;
    case 1:
      return event.virtualEventInfo.id;
    case 2:
      return event.hybridEventInfo.id;
  }
  return event.id;
}

export const adapter: EntityAdapter<any> = createEntityAdapter<any>({
  selectId: selectEventId
});

export const initialState: State = adapter.getInitialState({
  switcher: false,
  selectedEvent: null,
  search: '',
  eventConfig: null
});

export const reducer = createReducer(
  initialState,

  on(EventActions.updateEventListSwitcher, (state, { payload: switcher }) => {
    return { ...state, switcher }
  }),
  on(EventActions.loadEventList, state => state),
  on(EventActions.loadEventListSuccess, (state, { data }) => {
    return adapter.upsertMany(data, adapter.removeAll(state));
  }),
  on(EventActions.loadEventListFailure, (state, action) => state),

  on(EventActions.selectEvent, (state, { payload: selectedEvent }) => {
    return { ...state, selectedEvent }
  }),

  on(EventActions.deleteEventSuccess, (state, { payload }) => {
    const entities = _.map(state.entities, entity => {
      switch(entity.type) {
        case 0:
          if(payload.id === entity.inPersonEventInfo.id) {
            entity.inPersonEventInfo.status = payload.deleteValue ? 1: 0;
            return entity;
          }
          break;
      }
      return entity;
    })
    return { ...state, entities };
  }),

  on(EventActions.deleteVEventSuccess, (state, { payload }) => {
    const entities = _.map(state.entities, entity => {
      switch(entity.type) {
        case 1:
          if(payload.id === entity.virtualEventInfo.id) {
            entity.virtualEventInfo.status = payload.deleteValue ? 1: 0;
            return entity;
          }
          break;
      }
      return entity;
    })
    return { ...state, entities };
  }),

  on(EventActions.deleteHEventSuccess, (state, { payload }) => {
    const entities = _.map(state.entities, entity => {
      switch(entity.type) {
        case 2:
          if(payload.id === entity.hybridEventInfo.id) {
            entity.hybridEventInfo.status = payload.deleteValue ? 1: 0;
            return entity;
          }
          break;
      }
      return entity;
    })
    return { ...state, entities };
  }),

  on(EventActions.loadEventConfig, state => state),
  on(EventActions.loadEventConfigSuccess, (state, action) => {
    return {...state, eventConfig: action.data};
  }),
  on(EventActions.loadEventConfigFailure, (state, action) => {
    return state;
  }),

  on(EventActions.addEventPageBlock, state => state),
  on(EventActions.addEventPageBlockSuccess, (state, action) => {
    return {...state, action};
  }),
  on(EventActions.addEventPageBlockFailure, (state, action) => {
    return state;
  }),


  on(EventActions.removeEventPageBlock, state => state),
  on(EventActions.removeEventPageBlockSuccess, (state, action) => {
    return {...state, action};
  }),
  on(EventActions.removeEventPageBlockFailure, (state, action) => {
    return state;
  }),

  on(EventActions.updateEventConfigPage, state => state),
  on(EventActions.updateEventConfigPageSuccess, (state, action) => {
    return {...state, action};
  }),
  on(EventActions.updateEventConfigPageFailure, (state, action) => {
    return state;
  }),

  on(EventActions.addToCart, state => state),
  on(EventActions.addToCartSuccess, (state, action) => {
    return {...state, action};
  }),
  on(EventActions.addToCartFailure, (state, action) => {
    return state;
  }),

  on(EventActions.addRegistration, state => state),
  on(EventActions.addRegistrationSuccess, (state, action) => {
    return {...state, action};
  }),
  on(EventActions.addRegistrationFailure, (state, action) => {
    return state;
  }),

  on(EventActions.updateRegistration, state => state),
  on(EventActions.updateRegistrationSuccess, (state, action) => {
    return {...state, action};
  }),
  on(EventActions.updateRegistrationFailure, (state, action) => {
    return state;
  }),

  on(EventActions.removeRegistration, state => state),
  on(EventActions.removeRegistrationSuccess, (state, action) => {
    return {...state, action};
  }),
  on(EventActions.removeRegistrationFailure, (state, action) => {
    return state;
  }),

  on(EventActions.loadAllStreams, state => state),
  on(EventActions.loadAllStreamsSuccess, (state, action) => {
    return {...state, allStreams: action.data};
  }),
  on(EventActions.loadAllStreamsFailure, (state, action) => {
    return state;
  }),

  on(EventActions.loadVideoDownloadUrl, state => state),
  on(EventActions.loadVideoDownloadUrlSuccess, (state, action) => {
    return {...state, action};
  }),
  on(EventActions.loadVideoDownloadUrlFailure, (state, action) => {
    return state;
  }),

  on(EventActions.clearSelectedEvent, (state) => {
    return {
      ...state,
      selectedEvent: null
    }
  }),
);
